import React, { Component } from 'react';
import '../../Home/Home.css';

import { Link } from 'react-router-dom';

import icon8 from '../../../../image/icon8.png'
import icon9 from '../../../../image/icon9.svg'
class Footer extends Component {

    render() {

        return (
            <div className="home pt-5">
              <footer className="  p-lg-5 py-4 px-2">
                    <div className="container ">
                        <div className="row mx-0">
                            <div className="col-md-3">
                                <ul>
                                    <p className="font-weight-bold">اشترك معنا</p>
                                    <li className=" text-muted "><Link to="/AR/SignUp">سجل الان</Link></li>
                                    <li className=" text-muted "><Link to="/AR/Courier/SignUp">المندوبين</Link></li>
                                </ul>
                            </div>
                            <div className="col-md-3">
                                <ul>
                                    <p className="font-weight-bold">المساعده</p>
                                    <li className=" text-muted "><Link to="/AR/FAQS">الاسئله</Link></li>
                                    <li className=" text-muted "><Link to="/AR/ContactUs">للتواصل معنا</Link></li>

                                </ul>
                            </div>

                            <div className="col-md-3">

                                <ul>
                                    <p className="font-weight-bold">القوانين</p>
                                    <li className=" text-muted "><Link to="/AR/Policy">سياسة خاصة</Link></li>
                                    <li className=" text-muted "><Link to="/AR/termsconditions"> شروط لنا</Link></li>

                                </ul>
                            </div>

                            <div className="col-md-3">
                                <ul>
                                    <p className="font-weight-bold">تابعنا</p>
                                    <a href="https://www.facebook.com/Kayn-219444555581932/" target="_blank"><img className="m-3" src={icon9} alt="https://www.facebook.com/Kayn-219444555581932/" /></a>
                                    <a href="https://www.instagram.com/getkayn/" target="_blank"><img className="m-3 icon8" src={icon8} alt="https://www.instagram.com/getkayn/" /></a>
                                </ul>
                            </div>
                        </div>
                </div>
               
                <div className="col-md-4 mx-auto text-center">

                </div>
            </footer>
            </div>

        )
    }
}
export default Footer;